/**
 * User-Specific Actions
 * Actions defined specifically for the users entity
 * Strongly typed to user row type
 * Uses shared builders to eliminate duplication
 */

import type { DetailActionStrict } from "../../types/detail-action";
import {
  universalDeleteAction,
  universalEditAction,
  universalViewDetailsAction,
} from "../universal-actions";
import { ACTION_ICONS, ACTION_VARIANTS, ROLE_COMBINATIONS } from "../../types/action-properties";

/**
 * Complete user actions array
 * Combines universal and user-specific actions
 */
export const userDetailActions: DetailActionStrict<any>[] = [
  // PRIMARY ACTIONS (Header)
  universalEditAction<any>(),
  universalDeleteAction<any>(),

  // TABLE-ONLY ACTIONS
  universalViewDetailsAction<any>("viewDetails"),

  // SECONDARY ACTIONS (Menu)
  {
    id: "reset-password",
    label: "Reset Password",
    icon: ACTION_ICONS.PHONE,
    variant: ACTION_VARIANTS.OUTLINE,
    action: "resetPassword",
    allowedRoles: [...ROLE_COMBINATIONS.ADMIN_ONLY],
  },
  {
    id: "toggle-active",
    label: "Toggle Active Status",
    icon: ACTION_ICONS.SHIELD,
    variant: ACTION_VARIANTS.OUTLINE,
    action: "toggleActiveStatus",
    allowedRoles: [...ROLE_COMBINATIONS.ADMIN_ONLY],
  },
  {
    id: "manage-roles",
    label: "Manage Roles",
    icon: ACTION_ICONS.SHIELD,
    variant: ACTION_VARIANTS.OUTLINE,
    action: "manageRoles",
    allowedRoles: [...ROLE_COMBINATIONS.ADMIN_ONLY],
  },
];
